export default __webpack_public_path__ + "static/media/submit.0ba9273f.svg";